// extracted by mini-css-extract-plugin
export default {"create-form-page":"J1_sA","createFormPage":"J1_sA","appear-from-above":"aod6e","appearFromAbove":"aod6e"};